import {useMutation, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {User} from '@features/user/types.ts'
import {FloorPlanOptInPayload, httpFloorPlanOptIn} from '@features/floor-plan/http/floorPlan.http.ts'

/**
 * Submits the floor plan opt-in form. On success it marks the photographer as
 * opted in (`is3dScanEligible: true`) in the cached user, so the banner and
 * settings reflect the new state without an extra round-trip.
 */
export const useFloorPlanOptInSubmit = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (payload: FloorPlanOptInPayload) => httpFloorPlanOptIn({payload}),
        onSuccess: () => {
            queryClient.setQueryData<User>(
                [QUERY_KEYS.ME],
                previous => previous && {...previous, is3dScanEligible: true}
            )
        }
    })
}
